import { Button } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../common.ts";
import { View, Svg, Path, Circle, Rect, Line } from "@react-pdf/renderer";
import { BRAND, styles } from "./TripItineraryPDF.styles";

export const ROUTE_SEPARATOR = "  >  ";

export const getUniqueValues = (data = [], key) => {
  const set = new Set();
  data.forEach((item) => {
    if (
      item &&
      item[key] !== undefined &&
      item[key] !== null &&
      item[key] !== ""
    ) {
      set.add(item[key]);
    }
  });

  return Array.from(set).map((value) => ({
    text: String(value),
    value,
  }));
};
export const GlobeIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
    <path d="M2 12h20" />
  </svg>
);
export const UserIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const ZapIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

export const HeartIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
  </svg>
);
export const PAYMENT_OPTIONS = ["Payment Pending", "Paid", ""];
export const STATUS_OPTIONS = [
  "Created",
  "Assigned",
  "Discussed",
  "Quote Sent",
  "Invoiced",
  "Service Provided",
  "Service Canceled",
];
export const DEAL_OPTIONS = ["open", "closed"];
export const STATUS_COLORS = {
  Created: "blue",
  Assigned: "geekblue",
  Discussed: "magenta",
  "Quote Sent": "orange",
  Invoiced: "purple",
  "Service Provided": "green",
  "Service Canceled": "red",
};

export const PAYMENT_COLORS = {
  "Payment Pending": "orange",
  Paid: "green",
  "Refund Pending": "purple",
  "Refund Issued": "magenta",
  "": "default",
  Null: "default",
};

export const DEAL_COLORS = {
  open: "orange",
  closed: "green",
};
export const capitalize = (s = "") =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

const toDate = (ts) => {
  if (!ts || !ts.seconds) return null;
  const ms = ts.seconds * 1000 + (ts.nanoseconds || 0) / 1e6;
  return new Date(ms);
};

export const maskEmail = (email = "") => {
  if (!email) return "";
  const [user, domain] = email.split("@");
  if (!domain) return email;
  if (user.length <= 2) return `${user[0]}***@${domain}`;
  return `${user.slice(0, 4)}***@${domain}`;
};
export const maskPhone = (phone = "") => {
  if (!phone) return "";

  const digits = phone.replace(/\D/g, "");

  if (digits.length <= 4) return "*".repeat(digits.length);

  return `${"*".repeat(digits.length - 4)}${digits.slice(-4)}`;
};
export const normalizeEnquiries = (enquiries = []) =>
  enquiries.map((e) => {
    const createdAtDate = toDate(e.createdAt);
    return {
      key: e.id || e.enqNo,
      ...e,
      createdAtDate,
      createdAtDateStr: createdAtDate
        ? createdAtDate.toISOString().split("T")[0]
        : "",
    };
  });
export const tsToDayjs = (ts) => {
  if (!ts || !ts.seconds) return null;
  const ms = ts.seconds * 1000 + (ts.nanoseconds || 0) / 1e6;
  return dayjs(ms);
};

export const dayjsToTs = (d) => {
  if (!d) return null;
  const ms = d.valueOf();
  return {
    seconds: Math.floor(ms / 1000),
    nanoseconds: (ms % 1000) * 1e6,
  };
};
export const PopupBanner = ({ popup, POPUP_STORAGE_KEY, delayMs = 2500 }) => {
  const [visible, setVisible] = useState(false);
  let { imageUrl, route, enabled } = popup || {};
  useEffect(() => {
    if (!enabled) return;
    try {
      const dismissed = sessionStorage.getItem(POPUP_STORAGE_KEY);
      if (dismissed) return;
    } catch (e) {
      console.error("sessionStorage error", e);
      return;
    }

    const timer = setTimeout(() => {
      setVisible(true);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [imageUrl, delayMs, enabled, POPUP_STORAGE_KEY]);

  const handleClose = () => {
    setVisible(false);
    try {
      sessionStorage.setItem(POPUP_STORAGE_KEY, "1");
    } catch (e) {}
  };
  const handlePopupClick = () => {
    setVisible(false);
    try {
      sessionStorage.setItem(POPUP_STORAGE_KEY, "1");
      window.open(`${route}`, "_blank", "noopener,noreferrer");
    } catch (e) {}
  };

  if (!visible || !imageUrl) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
    >
      <div className="relative bg-white rounded-xl overflow-hidden max-w-md w-[90%] shadow-2xl">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 text-xl leading-none px-2"
          aria-label="Close offer"
        >
          ✕
        </button>

        <img src={imageUrl} alt="Offer" className="w-full h-auto block" />
        {route && (
          <Button
            type="primary"
            className="absolute bottom-4 left-1/2 -translate-x-1/2"
            onClick={handlePopupClick}
          >
            Click here
          </Button>
        )}
      </div>
    </div>
  );
};
export const tagProps = {
  "coming soon": { color: "orange", text: "Coming soon" },
  available: { color: "green", text: "Available" },
  "sold out": { color: "red", text: "Sold out" },
  "not available": { color: "red", text: "Not Available" },
};
export async function decrypetData(encryptedText) {
  const bytes = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY);
  const decryptedJsonStr = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedJsonStr);
}

export async function encryptData(payload) {
  const cipher = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    SECRET_KEY,
  ).toString();
  return cipher;
}

export const PdfIcon = ({ type, color, size = 13 }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      {type === "check" && (
        <>
          <Path
            d="M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Z"
            fill={color || "#238451"}
          />
          <Path
            d="m7 12.2 3.2 3.2L17.5 8"
            stroke="#FFFFFF"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </>
      )}

      {type === "close" && (
        <>
          <Path
            d="M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Z"
            fill={color || "#B54747"}
          />
          <Path
            d="m8 8 8 8m0-8-8 8"
            stroke="#FFFFFF"
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
          />
        </>
      )}

      {type === "moon" && (
        <Path
          d="M19.5 15.8A9 9 0 0 1 8.2 4.5 9.5 9.5 0 1 0 19.5 15.8Z"
          fill={color || "#6252A5"}
        />
      )}
    </Svg>
  );
};

export const PromotionIcon = ({ title }) => {
  const name = (title || "").toLowerCase();

  return (
    <Svg width={48} height={48} viewBox="0 0 48 48">
      {/* EMI - Credit Card */}
      {name.includes("emi") && (
        <>
          <Rect
            x="5"
            y="10"
            width="38"
            height="27"
            rx="4"
            stroke={BRAND.navy}
            strokeWidth="2"
            fill="none"
          />
          <Line
            x1="5"
            y1="19"
            x2="43"
            y2="19"
            stroke={BRAND.navy}
            strokeWidth="3"
          />
          <Line
            x1="11"
            y1="29"
            x2="23"
            y2="29"
            stroke={BRAND.navy}
            strokeWidth="2"
          />
        </>
      )}

      {/* EARLY BIRD - Flying Bird */}
      {name.includes("early") && (
        <Path
          d="M3 18 C11 10 18 11 24 19 C30 11 37 10 45 18 C36 16 30 20 24 27 C18 20 12 16 3 18 Z"
          fill={BRAND.navy}
        />
      )}

      {/* PAY 5 COME 6 - Shopping Cart */}
      {(name.includes("pay") || name.includes("come")) && (
        <>
          <Path
            d="M4 8 H11 L17 32 H39 L44 15 H13"
            stroke={BRAND.navy}
            strokeWidth="2.5"
            fill="none"
          />
          <Line
            x1="18"
            y1="21"
            x2="41"
            y2="21"
            stroke={BRAND.navy}
            strokeWidth="2"
          />
          <Line
            x1="23"
            y1="15"
            x2="25"
            y2="31"
            stroke={BRAND.navy}
            strokeWidth="2"
          />
          <Line
            x1="34"
            y1="15"
            x2="33"
            y2="31"
            stroke={BRAND.navy}
            strokeWidth="2"
          />
          <Circle cx="21" cy="39" r="3" fill={BRAND.navy} />
          <Circle cx="36" cy="39" r="3" fill={BRAND.navy} />
        </>
      )}
    </Svg>
  );
};

export const GroupBadgeIcon = () => (
  <View style={styles.iconPeople}>
    <Svg width={17} height={17} viewBox="0 0 24 24">
      <Circle cx="12" cy="7" r="3" fill="#FFFFFF" />
      <Circle cx="4.5" cy="9" r="2.3" fill="#FFFFFF" />
      <Circle cx="19.5" cy="9" r="2.3" fill="#FFFFFF" />

      <Path
        d="M5 20v-2.2c0-3.2 2.8-5.5 7-5.5s7 2.3 7 5.5V20H5Z"
        fill="#FFFFFF"
      />

      <Path
        d="M1 19v-2c0-2.3 1.4-4 3.8-4.6M23 19v-2c0-2.3-1.4-4-3.8-4.6"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        fill="none"
      />
    </Svg>
  </View>
);

export const CalendarBadgeIcon = () => (
  <View style={styles.iconCalendar}>
    <Svg width={16} height={16} viewBox="0 0 24 24">
      <Rect
        x="3"
        y="5"
        width="18"
        height="16"
        rx="2"
        stroke="#FFFFFF"
        strokeWidth="1.8"
        fill="none"
      />

      <Line x1="3" y1="9" x2="21" y2="9" stroke="#FFFFFF" strokeWidth="1.8" />

      <Line x1="8" y1="3" x2="8" y2="7" stroke="#FFFFFF" strokeWidth="2" />

      <Line x1="16" y1="3" x2="16" y2="7" stroke="#FFFFFF" strokeWidth="2" />

      <Circle cx="8" cy="13" r="1" fill="#FFFFFF" />
      <Circle cx="12" cy="13" r="1" fill="#FFFFFF" />
      <Circle cx="16" cy="13" r="1" fill="#FFFFFF" />
      <Circle cx="8" cy="17" r="1" fill="#FFFFFF" />
      <Circle cx="12" cy="17" r="1" fill="#FFFFFF" />
    </Svg>
  </View>
);

export const StatusBadgeIcon = () => (
  <View style={styles.iconStatus}>
    <Svg width={12} height={12} viewBox="0 0 24 24">
      <Path
        d="M5 12.5l4.5 4.5L19 7"
        stroke={BRAND.navy}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  </View>
);
